<template>
    <div :class="`sCountry${size ? ` ${size}` : ''} ${value}`">{{value}}</div>
</template>

<script>
export default {
    name: 'CountryBadge',
    props: {
        currency: {
            type: String,
            required: false
        },
        size: {
            type: String,
            required: false,
            default: ''
        },
        country: {
            type: String,
            required: false
        }
    },
    data() {
        return { }
    },
    computed: {
        value() {
            if (this.country) {
                switch (this.country) {
                    case 'USA':
                        return 'US'
                    case 'Canada':
                        return 'CA'
                    default:
                        return 'UNK'
                }
            }
            if (this.currency) {
                return this.currency.substring(0, 2).toUpperCase();
            }
            return 'UNK';
        }
    }
}
</script>

<style lang="scss" scoped>
.sCountry {
    width: 19px;
    height: 19px;
    border-radius: 10px;
    font-weight: normal;
    font-size: xx-small;
    border: solid 1px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.sCountry.sm {
    width: 16px;
    height: 16px;
    border-radius: 8px;
    font-size: 7px;
}

.sCountry.lg {
    width: 22px;
    height: 22px;
    border-radius: 11x;
    font-size: 10px;
}

.sCountry.US{
    background-color: #ccddff;
    color: #002368;
    border-color: #002368;
}

.sCountry.CA{
    background-color: #fad4d1;
    color: #d62718;
    border-color: #d62718;
}
</style>
